import produce from "immer";
import React, { ChangeEventHandler, FC } from "react";
import { ButtonGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { uuid } from "uuidv4";
import { startEditElement } from "../../../actions/elementListAction";
import { cssStyle } from "../../../models/cssStyleModel";
import { Element } from "../../../models/elementModel";
import { LabelAlignOptions } from "../../../utils/constants";
import CheckBoxComponent from "../../utilComponents/checkBoxComponent";
import ToggleButtonComponent from "../../utilComponents/toggleButtonComponent";
import chamalCasingCss from "./commonPropertyUtil/chamalCasingCss";

export interface LabelPropertiesProps {
  element: Element;
}

const LabelProperties: FC<LabelPropertiesProps> = ({ element }) => {
  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newElement = produce(element, (draft) => {
      draft.properties.labelPosition = e.target.value;
    });
    dispatch(startEditElement(newElement));
  };

  const removeLabel = () => {
    const newElement = produce(element, (draft) => {
      draft.properties.labelPosition = "";
      draft.properties.labelText = "";
    });
    dispatch(startEditElement(newElement));
  };

  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newElement = produce(element, (draft) => {
      draft.properties.lblCssStyles.push(newCssStyle);
    });
    dispatch(startEditElement(newElement));
  };

  const removeCssStyle = (index: number) => {
    const newElement = produce(element, (draft) => {
      draft.properties.lblCssStyles.splice(index, 1);
    });
    dispatch(startEditElement(newElement));
  };

  return (
    <div className="container mt-3">
      {/* <div className="card">
        <div className="card-header" id="LableProperties">
            <h5 className="mb-0">
                <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#lbl-prop" aria-expanded="false" aria-controls="lbl-prop">Lable Properties</button>
            </h5>
        </div>
        <div id="lbl-prop" className="collapse" aria-labelledby="LableProperties">
            <div className="card-body"> */}
      <div className="form-group col-12 m-2 p-2">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={removeLabel}
        >
          Remove Label <i className="fa fa-times"></i>
        </button>
      </div>
      <div className="form-group row">
        <label
          htmlFor="width"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          {element.type === "file" ? "File upload label" : "Label"}
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            className="form-control theam-textbox items-align-left"
            id="width"
            value={element.properties.labelText}
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.labelText = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="width"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        ></label>
        <div className="col-sm-8">
          <div className="row justify-content-around font-size-12 items-align-left">
            {/* <CheckBoxComponent
                      name="T"
                      checked={element.properties.labelPosition === "T"}
                      onChange={handleChange}
                    />
                    <CheckBoxComponent
                      name="R"
                      checked={element.properties.labelPosition === "R"}
                      onChange={handleChange}
                    />
                    <CheckBoxComponent
                      name="B"
                      checked={element.properties.labelPosition === "B"}
                      onChange={handleChange}
                    />
                    <CheckBoxComponent
                      name="L"
                      checked={element.properties.labelPosition === "L"}
                      onChange={handleChange}
                    /> */}
            <ButtonGroup>
              <ToggleButtonComponent
                name="T"
                checked={element.properties.labelPosition === "T"}
                onChange={handleChange}
              />
              <ToggleButtonComponent
                name="B"
                checked={element.properties.labelPosition === "B"}
                onChange={handleChange}
              />
              <ToggleButtonComponent
                name="L"
                checked={element.properties.labelPosition === "L"}
                onChange={handleChange}
              />
              <ToggleButtonComponent
                name="R"
                checked={element.properties.labelPosition === "R"}
                onChange={handleChange}
              />
            </ButtonGroup>
          </div>
        </div>
      </div>
      {(element.properties.labelPosition === "T" ||
        element.properties.labelPosition === "B") && (
        <div className="form-group row">
          <label
            htmlFor="width"
            className="col-sm-4 col-form-label font-size-12 align-text-left"
          >
            Label align
          </label>
          <div className="col-sm-8">
            <select
              value={element.properties.labelAlign}
              id="input-type items-align-left"
              className="form-control theam-textbox"
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.labelAlign = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
            >
              {LabelAlignOptions.map((item, i) => {
                return (
                  <option key={i} value={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      )}
      {/* </div>
        </div>
      </div> */}
      <h6>Label Advance Style Properties</h6>
      <div className="form-group col-12 m-2 p-2">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={addNewCssStyle}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>

      {element.properties.lblCssStyles?.map((_style: cssStyle, i: number) => {
        return (
          <div key={i}>
            <div className="form-group row">
              <div className="col-sm-10"></div>
              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-dark btn-sm font-size-12"
                  onClick={(e) => removeCssStyle(i)}
                >
                  <i className="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-5 noPadding">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`style${i}`}
                  value={_style.style}
                  placeholder="Css Property"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.lblCssStyles[i].style = e.target.value;
                      draft.properties.lblCssStyles[i].retrivedStyle =
                        chamalCasingCss(e.target.value);
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
              <div className="col-sm-1 noPadding">:</div>
              <div className="col-sm-6 noPadding">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`value${i}`}
                  value={_style.value}
                  placeholder="Enter Value"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.lblCssStyles[i].value = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LabelProperties;
